<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'

const i18n = getI18n()

const props = defineProps({
  continue: {
    type: Function,
    required: false,
  },
  back: {
    type: Function,
    required: false,
  },
  finish: {
    type: Function,
    required: false,
  },
  color: {
    type: String,
    required: false,
    default: 'primary',
  },
  icon: {
    type: String,
    required: false,
  },
  iconRight: {
    type: String,
    required: false,
    default: 'mdi-chevron-right',
  },
  finishLabel: {
    type: String,
    required: false,
    default: null,
  },
  disable: {
    type: Boolean,
    required: false,
  },
  loading: {
    type: Boolean,
    required: false,
  },
})

const disable = computed(() => { return props.disable })

</script>
<template>
  <q-stepper-navigation style="display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 0.5rem;">
    <q-btn
      v-if="props.back"
      :label="i18n.t('common.back')"
      @click="props.back()"
    />
    <slot />
    <q-btn
      v-if="props.continue"
      :color="props.color"
      :icon="props.icon"
      :icon-right="props.iconRight"
      :label="i18n.t('common.continue')"
      :disable="disable"
      @click="props.continue()"
    />
    <q-btn
      v-if="props.finish"
      :color="props.color"
      :icon="props.icon"
      :icon-right="props.iconRight"
      :label="props.finishLabel || i18n.t(props.finishLabel)"
      :disable="disable"
      :loading="props.loading"
      @click="props.finish()"
    />
  </q-stepper-navigation>
</template>
